import {Component, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import packageJson from '../../package.json';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {PdfViewerComponent} from './common/pdf-viewer/pdf-viewer.component';

export const error$ = signal<any>(null);

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NzModalModule, NzButtonComponent, PdfViewerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.less'
})
export class AppComponent {
  public version: string = packageJson.version;
  error = error$;

  constructor() {
    document.title = 'SRiMS ' + `[v${this.version}]`;
  }
}
